module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAIAAAA8CAIAAADDpPyuAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAABlJREFUeNpiZou+81fQiokBDEapwUgBBBgAgNcC/1T5jD8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/10.png
// module id = rhId
// module chunks = 1